export default {
    UserIdentities: 'User Identity|User Identities',
};
